module.exports = __webpack_public_path__ + "img/a-c.6b1de491.png";